// Explicit dev environment file, swapped in via angular.json's "development" build
// configuration's fileReplacements. Currently identical to environment.ts (the default) —
// kept as a separate file so dev has its own place to diverge from the ng-serve default
// without touching environment.ts, matching the sava_printing_b2c pattern.
// TODO(hitesh): replace with real dev-tenant values (see environment.ts's TODO).
export const environment = {
    SHEKHAWAT_BE_HOST_PORT: 'https://gbs.dev.be.savaapi.com',
    // WebSocket endpoint — must be a wss:// URL, not https://. Nothing consumes this
    // yet, so the previous https:// value was latent rather than actively broken.
    SHEKHAWAT_BE_WS_HOST_PORT: 'wss://gbs.dev.ws.savaapi.com',
    ADMIN_PATH: 'shekhawat',
    CUSTOM_API_PATH: 'shekhawat',
    production: false,
    ENV: 'DEV' as 'DEV' | 'PROD',
    INS: 'mongodb',
    DB: 'shekhawat_db',
    authProviderName: 'shekhawat_staff_auth',
    get SHEKHAWAT_BE_HOST_PORT_SITES(): string {
        return this.SHEKHAWAT_BE_HOST_PORT + '/api';
    },
};
